var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowGoForwardLine = function SvgArrowGoForwardLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18.055 7.5H11.6a5.4 5.4 0 0 0 0 10.8h8.1v1.8h-8.1a7.2 7.2 0 1 1 0-14.4h6.455l-2.283-2.282 1.273-1.273L21.5 6.6l-4.455 4.455-1.273-1.273z"
  })));
};
export default SvgArrowGoForwardLine;